import {
  CPSConfig,
  CPSConfigFunctionnality,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P0003605, P0003605Data } from './P0003605';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';

export class P0004800 extends IProduct {
  override deviceTableIndex: number = 9;

  override modelIdentifier?: string = 'P00048-00';

  override dataIdentifier?: string = 'P0004800';

  override manufacturerName?: string = 'ACWA';

  data: P0003605Data = new P0003605Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P0004800/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P0004800/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P0004800/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P0004800;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P0004800?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P0004800.tuto.installation.help.title',
      helpSlides: [
        'P0004800.tuto.installation.help.1',
        'P0004800.tuto.installation.help.2',
        'P0004800.tuto.installation.help.3',
        'P0004800.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0004800/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0004800/installation-1_dark.png',
          },
          text: 'P0004800.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0004800/installation-2.png',
            dark: '/assets/ecosystem/images/products/P0004800/installation-2_dark.png',
          },
          text: 'P0004800.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0004800/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0004800/installation-1_dark.png',
          },
          text: 'P0004800.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P0004800/update-2.png',
            dark: '/assets/ecosystem/images/products/P0004800/update-2_dark.png',
          },
          text: 'P0004800.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return new P0003605().getCPSConfig();
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return new P0003605().getEventProductFunctionalities();
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality,
  ): CPSConfigFunctionnality | null {
    return new P0003605().getCPSConfigByFonctionnality(functionnality);
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return new P0003605().getPropertyForOTAUpdate();
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 17;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).icIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.csv'
    );
  }
}
